module.exports = __webpack_public_path__ + "static/InvoicingAndAccounting-e5bdd048e332507a776c0a7c4ab80925.jpg";